import { IAssignmentSubmissionComment } from '@/entities/Assignment';
import { AttachmentsDownloadList } from '@/shared/ui/AttachmentsDownloadList';
import { UserAvatar } from '@/shared/ui/UserAvatar';
import { formatDateTimeWithAMPM } from '@/shared/lib/utils/formatLondonDateTime';

interface ISubmissionCommentProps {
  comment: IAssignmentSubmissionComment;
  userId: number | null;
  asListItem?: boolean;
}
export const SubmissionComment = ({
  comment,
  userId,
  asListItem = false,
}: ISubmissionCommentProps) => {
  const { author, text, createdAt, attachments } = comment;
  const isStaff = author.role === 'staff';
  const isOwner = author.id === userId;
  const Component = asListItem ? 'li' : 'div';
  return (
    <Component
      className={`flex flex-col rounded-[24px] gap-4 p-6 ${isOwner ? 'bg-white box-shadow-[0px_3px_12px_0px_#0000000D]' : 'bg-[#91AAFF1A]'}`}
    >
      <div className="flex justify-between items-center gap-4">
        <UserAvatar
          avatar={author.avatar}
          userName={author.username}
          href={isStaff ? `/staff/${author.id}` : undefined}
        />
        <div>
          <p className="text-grey-secondary font-medium text-sm">
            Sent:
            <span className="ml-1 text-[#211D55] font-bold">
              {formatDateTimeWithAMPM(createdAt)}
            </span>
          </p>
        </div>
      </div>
      <p className="text-black">{text}</p>
      {attachments.length > 0 && <AttachmentsDownloadList attachments={attachments} />}
    </Component>
  );
};
